import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from "element-ui";
import  'element-ui/lib/theme-chalk/index.css'
import VueClipboard from 'vue-clipboard2'

console.log("process.env.NODE_ENV",process.env.NODE_ENV);

import conf from "./conf";
conf(process.env.NODE_ENV);
Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(VueClipboard);

router.beforeEach((to,from,next)=>{
  if(to.meta.title){
    document.title = to.meta.title
  }
  next()
})
new Vue({
  router,
  store,
  render: h => h(App),
  mounted () {
  // You'll need this for renderAfterDocumentEvent.
  document.dispatchEvent(new Event('render-active'))
  }
}).$mount('#app')
